import "vite-dep-pre-bundle-external:/home/cmiss/Jenkins/workspace/map-viewer-release/node_modules/maplibre-gl/dist/maplibre-gl.css";